import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCart, X } from 'lucide-react';
const NAMES = ['María García', 'Carlos López', 'Ana Martínez', 'Valentina Rodríguez', 'Diego Fernández', 'Camila Torres', 'Sebastián Morales', 'Lucía Herrera', 'Mateo Silva', 'Isabella Ramírez', 'Sofía Castro', 'Joaquín Mendoza'];
const CITIES = ['Buenos Aires', 'Bogotá', 'Ciudad de México', 'Lima', 'Santiago', 'Medellín', 'Quito', 'Montevideo', 'San José', 'Guadalajara', 'Córdoba', 'Rosario'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentCity, setCurrentCity] = useState('');
  const showPopup = useCallback(() => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    setCurrentName(randomName);
    setCurrentCity(randomCity);
    setIsVisible(true);
    setTimeout(() => setIsVisible(false), 4000);
  }, []);
  useEffect(() => {
    const initialTimer = setTimeout(showPopup, 5000);
    const interval = setInterval(showPopup, 30000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, [showPopup]);
  return <AnimatePresence data-id="element-266">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 right-4 md:top-auto md:left-auto md:right-auto md:bottom-6 md:left-6 z-50 max-w-sm bg-white rounded-xl shadow-premium p-3 md:p-4 border border-soft-gray flex items-start gap-3 md:gap-4" data-id="element-267">
          <div className="bg-sky/20 p-2 rounded-full text-sky flex-shrink-0 mt-1" data-id="element-268">
            <ShoppingCart size={18} data-id="element-269" />
          </div>
          <div className="flex-1 pr-4" data-id="element-270">
            <p className="text-sm text-navy font-medium" data-id="element-271">
              <span className="font-bold" data-id="element-272">{currentName}</span> de {currentCity}{' '}
              acaba de comprar este libro digital
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-273">Hace unos minutos</p>
          </div>
          <button onClick={() => setIsVisible(false)} className="text-gray-400 hover:text-gray-600 absolute top-3 right-3" data-id="element-274">
            <X size={16} data-id="element-275" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}